<template>
    <div class="comparison">
        <table class="comparison__table">
            <thead>
                <tr>
                    <th></th>
                    <th>{{ $t('FREE') }}</th>
                    <th>PLUS</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        <html-with-links tag="span" :html="$t('DEDICATED_FAST_SERVERS')" />
                    </td>
                    <td>
                        <Icon icon="tabler:x" class="no-icon" />
                    </td>
                    <td>
                        <Icon icon="tabler:check" class="yes-icon" />
                    </td>
                </tr>
                <tr>
                    <td>
                        <html-with-links tag="span" :html="$t('ACCESS_TO_APP_REQUESTS', { href: '/requests' })" />
                    </td>
                    <td>
                        <Icon icon="tabler:x" class="no-icon" />
                    </td>
                    <td>
                        <Icon icon="tabler:check" class="yes-icon" />
                    </td>
                </tr>
                <tr>
                    <td>{{ $t('NO_ADS') }}</td>
                    <td>
                        <Icon icon="tabler:x" class="no-icon" />
                    </td>
                    <td>
                        <Icon icon="tabler:check" class="yes-icon" />
                    </td>
                </tr>
                <tr>
                    <td>
                        <html-with-links tag="span"
                            :html="$t('PREMIUM_SUPPORT_VIA_HELPDESK', { href: 'https://appdb.to/my/support/' })" />
                    </td>
                    <td>
                        <Icon icon="tabler:x" class="no-icon" />
                    </td>
                    <td>
                        <Icon icon="tabler:check" class="yes-icon" />
                    </td>
                </tr>
                <tr>
                    <td>{{ $t('APP_INSTALLATIONS') }}</td>
                    <td>{{ $t('N_PER_WEEK', { n: 10 }) }}</td>
                    <td>{{ $t('UNLIMITED') }}</td>
                </tr>
                <tr>
                    <td>
                        <html-with-links tag="span" :html="$t('STORAGE_FOR_IPA_LIBRARY', { href: '/my/apps' }) + '*'" />
                    </td>
                    <td>1 GB</td>
                    <td>30 GB</td>
                </tr>
                <tr>
                    <td>{{ $t('MAX_UPLOAD_SIZE') }}</td>
                    <td>256 MB</td>
                    <td>4 GB</td>
                </tr>
            </tbody>
        </table>
        <p class="comparison__footnote">* {{ $t('STORAGE_FOR_IPA_LIBRARY_FOOTNOTE') }}</p>
    </div>
</template>

<script>
import { Icon } from '@iconify/vue2';
import HtmlWithLinks from './HtmlWithLinks.vue';

export default {
  components: {
    Icon,
    HtmlWithLinks,
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/variables';

.comparison {
    margin-bottom: 25px;

    &__table {
        width: 100%;

        th {
            border-bottom: 1px solid #dcd9d9;
            padding-bottom: 10px;
            font-weight: 600;
        }

        td {
            padding: 10px;
            vertical-align: middle;
            white-space: pre-line;
            line-height: 1.2;
        }

        td:first-child {
            width: 35%;

            @include tablet {
                width: auto;
            }
        }

        td:not(:last-child) {
            border-right: 1px solid #dcd9d9;
        }

        tr:not(:last-child) td {
            border-bottom: 1px solid #dcd9d9;
        }

        td:not(:first-child) {
            text-align: center;
        }

        td:first-child {
            @include tablet {
                width: 150px;
            }
        }
    }

    &__footnote {
        margin-top: 10px;
        font-size: 12px;
    }
}

.no-icon,
.yes-icon {
    font-size: 22px;
    vertical-align: middle;
}

.no-icon {
    color: var(--text-error);
}

.yes-icon {
    color: var(--text-success);
}
</style>
